import { PrayerType, DayType } from '../types';

/** Display / resolve order for all prayer types. */
export const PRAYER_TYPES: PrayerType[] = [
  'selichot',
  'shacharit',
  'tekiot',
  'yizkor',
  'musaf',
  'mincha',
  'kabalatShabbat',
  'tefilahZakha',
  'neila',
  'maariv',
  'megillah',
  'hakafot',
  'custom',
];

export const DAY_TYPES: DayType[] = [
  'weekday',
  'sheniHamishi',
  'roshChodesh',
  'chanukah',
  'beinHazmanim',
  'behab',
  'aseretYemeiTeshuva',
  'fastMinor',
  'fastFriday',
  'purim',
  'purimFriday',
  'erevTishaBav',
  'tishaBav',
  'erevShabbos',
  'chanukahFriday',
  'shabbos',
  'chanukahShabbos',
  'erevYomTov',
  'yomTov',
  'roshHashana',
  'roshHashanaFriday',
  'sukkotI',
  'simchatTorah',
  'pesachI',
  'shviiShelPesach',
  'shavuot',
  'yomTovFriday',
  'cholHaMoed',
  'hoshanaRabba',
  'erevYomKippur',
  'yomKippur',
  'selichotFirstNight',
  'selichotBeforeRH',
  'erevRoshHashana',
  'tzomGedalia',
];

export const DAY_TYPE_SECTIONS: {
  key: 'weekday' | 'shabbos' | 'yomTov' | 'selichot';
  dayTypes: DayType[];
}[] = [
  {
    key: 'weekday',
    dayTypes: [
      'weekday', 'sheniHamishi', 'roshChodesh', 'chanukah', 'beinHazmanim', 'aseretYemeiTeshuva', 'fastMinor',
      'fastFriday', 'purim', 'purimFriday', 'erevTishaBav', 'tishaBav',
    ],
  },
  { key: 'shabbos', dayTypes: ['erevShabbos', 'chanukahFriday', 'shabbos', 'chanukahShabbos'] },
  {
    key: 'yomTov',
    dayTypes: [
      'erevYomTov',
      'yomTov',
      'roshHashana',
      'roshHashanaFriday',
      'sukkotI',
      'simchatTorah',
      'pesachI',
      'shviiShelPesach',
      'shavuot',
      'yomTovFriday',
      'cholHaMoed',
      'hoshanaRabba',
      'erevYomKippur',
      'yomKippur',
    ],
  },
  {
    key: 'selichot',
    dayTypes: ['selichotFirstNight', 'selichotBeforeRH', 'erevRoshHashana', 'tzomGedalia', 'behab'],
  },
];

/**
 * Candle lighting: minutes before sunset from the height (the local calendar
 * "Itim LeBina" uses 40; Yoel, November 4, 2026).
 */
export const CANDLE_LIGHTING_MINUTES_BEFORE_SUNSET = 40;

/**
 * Tzeit HaKochavim / Shabbos ends when the app calculates it itself (Hebcal):
 * the sun this many degrees below the horizon. Matches MyZmanim's "NightShabbos"
 * and the local calendar's "Tzeit HaShabbos" within a minute (Yoel, November 4, 2026).
 */
export const TZEIT_SUN_DEGREES = 8.5;

/** Tzeit according to Rabbeinu Tam: sunset (from the height) + 72 minutes. */
export const RABBEINU_TAM_MINUTES_AFTER_SUNSET = 72;

/** The neighborhood's height in meters (MyZmanim uses 205 for Beit Shemesh); used for sunset from the height. */
export const NEIGHBORHOOD_ELEVATION_METERS = 205;

export const NEIGHBORHOOD_COORDS = {
  lat: 31.702125,
  lng: 35.003423,
};

/** Max upload size for cover images and posters (Storage rules enforce the same). */
export const MAX_UPLOAD_BYTES = 8 * 1024 * 1024;

export const MYZMANIM_FIELDS: Record<string, string> = {
  AlotHashachar: 'עלות השחר',
  Sunrise: 'נץ החמה',
  SunsetDefault: 'שקיעה',
  Tzet: 'צאת הכוכבים',
  TzetRabbeinuTam: 'צאת הכוכבים לרבנו תם',
  Chatzot: 'חצות',
  MinchaGedola: 'מנחה גדולה',
  MinchaKetana: 'מנחה קטנה',
  PlagHamincha: 'פלג המנחה',
  ShemaMA: 'סוף זמן קריאת שמע לפי המגן אברהם',
  ShemaGra: 'סוף זמן קריאת שמע לפי הגר״א',
};

/** Opening hours: "Opens soon" within this many minutes. */
export const OPENS_SOON_MINUTES = 60;

/** Opening hours: "Closes soon" within this many minutes. */
export const CLOSES_SOON_MINUTES = 30;

/** Listing messages can stay up for at most this many months. */
export const MAX_MESSAGE_MONTHS = 3;
